import { useCallback, useEffect, useRef, useState } from 'react';

const IDLE_TIMEOUT = 30 * 60 * 1000;   // 30 minutes
const WARNING_BEFORE = 2 * 60 * 1000;  // warn 2 minutes before logout

const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll', 'click'];

export function useIdleTimeout(onIdle) {
    const [showWarning, setShowWarning] = useState(false);
    const [remainingSeconds, setRemainingSeconds] = useState(WARNING_BEFORE / 1000);
    const idleTimer = useRef(null);
    const warningTimer = useRef(null);
    const countdown = useRef(null);
    const onIdleRef = useRef(onIdle);
    onIdleRef.current = onIdle;

    const startTimers = useCallback(() => {
        clearTimeout(idleTimer.current);
        clearTimeout(warningTimer.current);
        clearInterval(countdown.current);
        setShowWarning(false);

        warningTimer.current = setTimeout(() => {
            setShowWarning(true);
            setRemainingSeconds(WARNING_BEFORE / 1000);
            countdown.current = setInterval(() => {
                setRemainingSeconds(prev => Math.max(0, prev - 1));
            }, 1000);
        }, IDLE_TIMEOUT - WARNING_BEFORE);

        idleTimer.current = setTimeout(() => {
            clearTimeout(warningTimer.current);
            clearInterval(countdown.current);
            setShowWarning(false);
            onIdleRef.current();
        }, IDLE_TIMEOUT);
    }, []);

    useEffect(() => {
        startTimers();
        ACTIVITY_EVENTS.forEach(e => window.addEventListener(e, startTimers, { passive: true }));
        return () => {
            clearTimeout(idleTimer.current);
            clearTimeout(warningTimer.current);
            clearInterval(countdown.current);
            ACTIVITY_EVENTS.forEach(e => window.removeEventListener(e, startTimers));
        };
    }, [startTimers]);

    return { showWarning, remainingSeconds, extendSession: startTimers };
}